import angular from 'angular'
import collection from './collection'
import management from './management'
import rollout from './rollout'
import InvAccountManagement from './InvAccountManagement'
export default angular
    .module('input.inputInvoice', [collection, management, rollout, InvAccountManagement])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.inputInvoice', {
            abstract: true,
            url: '/inputInvoice',
            template: '<div ui-view></div>',
            title: '进项票管理',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/index.js